module.exports = __webpack_public_path__ + "img/37.58f8a643.svg";